// @flow
import React from 'react';
import { Jumbo } from '@finect/tabular-components/Jumbo';
import { Section } from '@finect/tabular-components/Section';

export const RiskProfileJumbo = () => (
  <Section bottomMargin>
    <Jumbo
      id="risk-profile"
      contentPosition="left"
      textAlign="left"
      color="#2a2a2a"
      title="Conoce tu perfil inversor"
      subtitle={`Descubre tu perfil inversor con este sencillo test para descubrir los productos que mejor se adaptan a tus objetivos.`}
      cta="Comenzar"
      coverImage="https://www.finect.com/image/6602a674b0036f6f1113e9adcf88cf35bf6f384270a"
      link="https://www.finect.com/pills/es_ES/finect/default/conoce-tu-perfil-inversor"
    />
  </Section>
);
